module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-vodafonerebranding-03@2x.e526dd00.jpg";